import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';

const FAQ = () => {
  const faqs = [
    {
      question: "What can I expect during my first visit?",
      answer: "Your first visit will include a comprehensive consultation, a review of your medical history, and a physical examination to understand your specific needs. If appropriate, we may perform an initial adjustment or develop a treatment plan tailored to you."
    },
    {
      question: "Is chiropractic care safe?",
      answer: "Yes, chiropractic care is widely recognized as one of the safest drug-free, non-invasive therapies available for the treatment of neuromusculoskeletal complaints. Dr. Huerta Roman uses gentle, precise techniques tailored to each patient."
    },
    {
      question: "How many sessions will I need?",
      answer: "The number of sessions varies depending on your specific condition, how long you've had it, and your overall health goals. We will provide a personalized care plan after your initial assessment."
    },
    {
      question: "Do adjustments hurt?",
      answer: "Most patients feel immediate relief following an adjustment. You may feel a slight pressure or a popping sound, which is just the release of gas from the joint. Some mild soreness, similar to post-workout muscle soreness, can occur but typically fades quickly."
    },
    {
      question: "",
      answer: "We accept various insurance plans. Please contact our office with your insurance information, and we will be happy to verify your benefits before your appointment."
    }
  ];

  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-24 bg-cream">
      <div className="container-custom max-w-4xl">
        <div className="text-center mb-16">
          <span className="text-text-secondary font-medium tracking-widest uppercase text-sm mb-4 block">Common Questions</span>
          <h2
            className="text-4xl md:text-5xl font-serif font-bold text-forest mb-6"
            style={{
              color: "#4f5a33"
            }}>Frequently Asked Questions</h2>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              className="border-b border-divider"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full py-6 flex justify-between items-center text-left focus:outline-none group"
              >
                <span className="text-xl font-serif font-medium text-forest group-hover:text-forest-light transition-colors">
                  {faq.question}
                </span>
                <span className="text-text-secondary ml-4">
                  {index !== 4 && (activeIndex === index ? <Minus size={20} /> : <Plus size={20} />)}
                </span>
              </button>
              <AnimatePresence>
                {activeIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="overflow-hidden"
                  >
                    <p className="pb-6 text-text-secondary font-light leading-relaxed">
                      {faq.answer}
                    </p>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
